import { graphql, useStaticQuery } from 'gatsby';

export default function ManufacturingMenuLinks() {
  const ManufacturingMenu = useStaticQuery(graphql`
    query MyManufacturingQuery {
      allMenuLinkContentManufacturing {
        nodes {
          id: drupal_id
          langcode
          parent: drupal_parent_menu_item
          link {
            uri
          }
          title
          weight
        }
      }
      allPathAliasPathAlias {
        nodes {
          alias
          langcode
          path
        }
      }
    }
  `);

  return ManufacturingMenu;
}
